<template>
  <div @click="viewDescription">
    <div class="flex h-28 w-32">
      <img
        v-if="!imageUrl"
        alt="image"
        class="h-6 w-6 m-auto animate-spin object-contain"
        src="@/assets/icons/spinner.svg"
      />
      <img
        v-else
        alt="image"
        class="h-full w-full rounded-sm object-cover"
        :src="imageUrl"
      />
    </div>
    <p class="w-32">{{ $store.getters.menuItem(menuID)?.title }}</p>
  </div>
</template>

<script>
import { Filesystem, Directory, Encoding } from "@capacitor/filesystem";
export default {
  props: { menuID: String },
  created() {
    this.fetchCachedImage();
  },
  data() {
    return {
      imageUrl: "",
    };
  },
  computed: {
    menuItem() {
      return this.$store.getters.menuItem(this.menuID);
    },
  },
  methods: {
    viewDescription() {
      try {
        var recentArray = JSON.parse(localStorage.recent);
        recentArray = recentArray.filter((e) => e != this.menuID);
        recentArray.unshift(this.menuID);
        localStorage.recent = JSON.stringify(recentArray.slice(0, 10));
      } catch {
        var newArray = [this.menuID];
        localStorage.recent = JSON.stringify(newArray);
      }
      this.$router.push({
        name: "MenuDescription",
        params: { menuID: this.menuID },
      });
    },
    fetchCachedImage() {
      if (this.menuItem) {
        var title = this.menuItem?.title;
        var urlImage =
          this.menuItem?.imageUrl || require("@/assets/logograysquare.png");
        Filesystem.readFile({
          path: `menuImages/${title}`,
          directory: Directory.Data,
          encoding: Encoding.UTF8,
        })
          .then((result) => {
            this.imageUrl = result.data.slice(
              result.data.indexOf("data:image/")
            );
          })
          .catch(() => {
            this.imageUrl = urlImage;
          });
      }
    },
  },
  watch: {
    menuItem() {
      this.fetchCachedImage();
    },
  },
};
</script>
